export function rundeKaufmaennisch(x: number): number {
    return x < 0 ? -Math.round(-x) : Math.round(x)
}

export function rundeKaufmaennisch2Digits(x: number): number {
    return rundeKaufmaennisch(x * 100) / 100
}
